// extracted by mini-css-extract-plugin
export var navbarSubLink = "H_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "H_tM d_f0 d_dB";
export var subPageLink = "H_gf d_gf";
export var burger = "H_wb";
export var sublinkSize = "H_wc";
export var linkSize = "H_wd";
export var Link = "H_sv t_sv t_rT t_sc";